import { render, staticRenderFns } from "./productionManage.vue?vue&type=template&id=5f37391a&scoped=true"
import script from "./productionManage.vue?vue&type=script&lang=js"
export * from "./productionManage.vue?vue&type=script&lang=js"
import style0 from "./productionManage.vue?vue&type=style&index=0&id=5f37391a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37391a",
  null
  
)

export default component.exports